import { useQuery } from '@tanstack/react-query'
import { getFreelancersDetail } from '@/apis/freelancers'
import { useApiReady } from '@/hooks/useApiReady'

// Query keys
export const freelancerDetailKeys = {
  all: ['freelancerDetail'] as const,
  detail: (freelancerId: string) => [...freelancerDetailKeys.all, 'detail', freelancerId] as const,
}

/**
 * Hook pour récupérer les détails d'un freelancer
 */
export function useFreelancerDetail(freelancerId: string | undefined, options?: { enabled?: boolean }) {
  const apiReady = useApiReady()

  return useQuery({
    queryKey: freelancerDetailKeys.detail(freelancerId || ''),
    queryFn: async () => {
      if (!freelancerId) {
        throw new Error('Freelancer ID is required')
      }
      const res = await getFreelancersDetail(freelancerId)
      if (res.data?.code === 200) {
        return res.data?.data || {}
      }
      throw new Error(res.data?.message || 'Failed to fetch freelancer detail')
    },
    enabled: apiReady && options?.enabled !== false && !!freelancerId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnWindowFocus: true,
  })
}
